export default "__VITE_ASSET__ea04e245__"